import { render, staticRenderFns } from "./dealer-list.vue?vue&type=template&id=b4d7403a&scoped=true&"
import script from "./dealer-list.vue?vue&type=script&lang=js&"
export * from "./dealer-list.vue?vue&type=script&lang=js&"
import style0 from "./dealer-list.vue?vue&type=style&index=0&id=b4d7403a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d7403a",
  null
  
)

export default component.exports